import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DiscoveryManager } from '../../../../managers/discovery.manager';
import { ReviewSet } from '../../../../models/ui/review-set.model';

@Component({
    selector: 'lex-create-review-sets-dialog',
    templateUrl: './modify-review-set-dialog.component.html',
    styleUrls: ['./modify-review-set-dialog.component.scss'],
    standalone: false
})
export class ModifyReviewSetDialogComponent {
	public newReviewSetForm: UntypedFormGroup;
	public reviewSet: ReviewSet;
	public mode: 'editing' | 'creating';

	constructor(
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<ModifyReviewSetDialogComponent>,
		private discoveryManager: DiscoveryManager,
		@Inject(MAT_DIALOG_DATA) existingReviewSet: ReviewSet,
	) {
		this.reviewSet = existingReviewSet;
		this.mode = existingReviewSet ? 'editing' : 'creating';
		this.newReviewSetForm = this.formBuilder.group({
			reviewSetName: [existingReviewSet?.name || '', [Validators.required]],
			reviewOrder: [existingReviewSet?.reviewOrder || 'master-date']
		});
	}

	public addNewReviewBatch(): void {
		const set = new ReviewSet();
		set.name = this.newReviewSetForm.controls['reviewSetName'].value;
		set.reviewOrder = this.newReviewSetForm.controls['reviewOrder'].value;

		this.discoveryManager.addReviewSet({ set }).subscribe((newReviewSet) => {
			this.dialogRef.close({reviewSet: newReviewSet});
		});
	}

	public saveReviewSet(): void {
		this.reviewSet.name = this.newReviewSetForm.controls['reviewSetName'].value;
		this.reviewSet.reviewOrder = this.newReviewSetForm.controls['reviewOrder'].value;

		this.discoveryManager.saveReviewSet({ set: this.reviewSet }).subscribe(() => {
			this.dialogRef.close();
		});
	}
}
